(ns frontend.test.ck-editor.view
  (:require
   [reagent.core :as r]
   [ui.components.ck-editor.view :as ck-editor]
   [ui.components.rich-text.view :as rich-text]))

(defn view
  []
  (let [local-state (r/atom {})]
    (fn []
      [:div
       {:class "flex flex-col gap-4 p-4"}
       [ck-editor/editor
        {:value   (:content @local-state)
         :on-blur #(swap! local-state assoc :content %)}]
       ;^{:key (:content @local-state)}
       #_[rich-text/editor
        {:value          (:content @local-state)
         :reset-content? true
         :on-focus       #()
         :on-blur        #()
         :on-change       #(swap! local-state assoc :content %)
         }]
       ]
      )))
